import { render } from "./TextEditorFieldsToolbar.vue?vue&type=template&id=77b9798f&scoped=true"
import script from "./TextEditorFieldsToolbar.vue?vue&type=script&lang=js"
export * from "./TextEditorFieldsToolbar.vue?vue&type=script&lang=js"

import "./TextEditorFieldsToolbar.vue?vue&type=style&index=0&id=77b9798f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77b9798f"]])

export default __exports__
import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'directives', {ClosePopup});
